module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst {\ntype,\nstatus,\n} = attributes\nconst additionalClasses = []\nlet symbol = ''\nif(type){\nsymbol = `fi fi-${type}`\nif(type === 'notAvailable' || status === 'confirmed'){\nadditionalClasses.push('confirmed')\n} else if(status === 'rejected'){\nadditionalClasses.push('rejected')\n}\n}\n%><div class=\"<%= additionalClasses.join(' ') %>\"><%\n%><i class=\"<%= symbol || 'fi fi-circle-question' %>\"></i><%\n%></div>"
  , __filename = "components/templates/core/table/fields/absenceTypeAndStatus.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const {
type,
status,
} = attributes
const additionalClasses = []
let symbol = ''
if(type){
symbol = `fi fi-${type}`
if(type === 'notAvailable' || status === 'confirmed'){
additionalClasses.push('confirmed')
} else if(status === 'rejected'){
additionalClasses.push('rejected')
}
}

    ; __line = 18
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">")
    ; 

    ; __line = 19
    ; __append("<i class=\"")
    ; __append(escapeFn( symbol || 'fi fi-circle-question' ))
    ; __append("\"></i>")
    ; 

    ; __line = 20
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/table/fields/absenceTypeAndStatus.ejs

}